/* Same prop sets as @coreui/vue v3; `modelValue` added so plain `v-model` works under Vue 3. */
const formGroupAlwaysSharedProps = {
  validFeedback: String,
  invalidFeedback: String,
  tooltipFeedback: Boolean,
  description: String
}
const formGroupSharedProps = Object.assign({}, formGroupAlwaysSharedProps, { append: String, prepend: String })
export const formGroupProps = Object.assign({}, formGroupSharedProps, { wrapperClasses: [String, Array, Object] })
const universalProps = {
  label: String,
  wasValidated: Boolean,
  isValid: { type: [Boolean, Function], default: null },
  addInputClasses: [String, Array, Object],
  addLabelClasses: [String, Array, Object]
}
const props = Object.assign({}, universalProps, {
  horizontal: [Boolean, Object],
  size: String,
  addWrapperClasses: [String, Array, Object]
})
const textInputsProps = {
  readonly: Boolean,
  plaintext: Boolean,
  value: { type: [String, Number], default: undefined },
  modelValue: { type: [String, Number], default: undefined },
  lazy: { type: [Boolean, Number], default: 400 }
}
export const inputFileProps = Object.assign({}, formGroupAlwaysSharedProps, props, {
  custom: Boolean,
  placeholder: String,
  multiple: Boolean
})
export const textareaProps = Object.assign({}, formGroupSharedProps, props, textInputsProps)
export const inputProps = Object.assign({}, formGroupSharedProps, props, textInputsProps, {
  type: { type: String, default: 'text' }
})
export const selectProps = Object.assign({}, formGroupSharedProps, props, {
  options: Array,
  value: { type: [String, Number, Boolean, Array, Event], default: undefined },
  modelValue: { type: [String, Number, Boolean, Array], default: undefined },
  plaintext: Boolean,
  placeholder: String,
  custom: Boolean
})
export const inputCheckboxProps = Object.assign({}, formGroupAlwaysSharedProps, universalProps, {
  checked: Boolean,
  custom: Boolean,
  inline: Boolean
})
